import React, { useState } from 'react';
import CardList from './cardList';
import { Button, Pagination, Typography } from '@mui/material';
import { Container } from '@mui/system';
import './wordCard.css';
import { groups, TextBookConstants, colors, } from '../../constants/TextBook.constants';
import { Link } from 'react-router-dom';
export var TextBook = function () {
    var _a = useState(JSON.parse(localStorage.getItem(TextBookConstants.TEXT_BOOK_INFO))
        ? JSON.parse(localStorage.getItem(TextBookConstants.TEXT_BOOK_INFO)).page
        : 1), page = _a[0], setPage = _a[1];
    var _b = useState(JSON.parse(localStorage.getItem(TextBookConstants.TEXT_BOOK_INFO))
        ? JSON.parse(localStorage.getItem(TextBookConstants.TEXT_BOOK_INFO))
            .group
        : 1), group = _b[0], setGroup = _b[1];
    var _c = useState(JSON.parse(localStorage.getItem(TextBookConstants.TEXT_BOOK_INFO))
        ? JSON.parse(localStorage.getItem(TextBookConstants.TEXT_BOOK_INFO))
            .color
        : 'lightgreen'), color = _c[0], setColor = _c[1];
    var _d = useState(false), allLearned = _d[0], setAllLearned = _d[1];
    var updateAllLearned = function (value) {
        setAllLearned(value);
    };
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement(Typography, { variant: "h3", textAlign: "center", sx: { p: 2 } }, "\u042D\u041B\u0415\u041A\u0422\u0420\u041E\u041D\u041D\u042B\u0419 \u0423\u0427\u0415\u0411\u041D\u0418\u041A"),
        React.createElement(Typography, { variant: "h5", textAlign: "center", sx: { p: 2 } }, group === 7 ? 'Сложные слова' : "\u0423\u0440\u043E\u0432\u0435\u043D\u044C ".concat(group, ", \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ").concat(page)),
        React.createElement(Container, { maxWidth: "sm", sx: { display: 'flex', p: 2 } },
            groups.map(function (group, index) {
                return (React.createElement(Container, { onClick: function () {
                        setGroup(group);
                        setColor(colors[index]);
                        setPage(1);
                        localStorage.setItem(TextBookConstants.TEXT_BOOK_INFO, JSON.stringify({ group: group, color: colors[index], page: 1 }));
                    }, onKeyDown: function () { return setGroup(group); }, key: String(group) + 'key', id: String(group) + 'group', sx: {
                        backgroundColor: colors[index],
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        border: '1px solid black',
                        cursor: 'pointer',
                        ':hover': {
                            boxShadow: '6px 6px rgba(0, 0, 255, .2)',
                        },
                    } }, group));
            }),
            localStorage.userInfo ? (React.createElement(Container, { onClick: function () {
                    setGroup(7);
                    setColor('brown');
                    setPage(1);
                    localStorage.setItem(TextBookConstants.TEXT_BOOK_INFO, JSON.stringify({ group: 7, color: 'brown', page: 1 }));
                }, onKeyDown: function () { return setGroup(7); }, key: String(7) + 'key', id: String(7) + 'group', sx: {
                    backgroundColor: 'brown',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    border: '1px solid black',
                    ':hover': {
                        boxShadow: '6px 6px rgba(0, 0, 255, .2)',
                    },
                } }, 7)) : null),
        React.createElement(Container, { maxWidth: "sm", sx: {
                p: 3,
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                justifySelf: 'center',
                alignSelf: 'center',
            } },
            React.createElement(Link, { to: group !== 7 && !allLearned
                    ? "/audio/".concat(group, "/").concat(page)
                    : window.location, style: { textDecoration: 'none' } },
                React.createElement(Button, { variant: "contained", disabled: group === 7 || allLearned ? true : false, sx: { backgroundColor: color, mr: 5 } }, "\u0410\u0443\u0434\u0438\u043E\u0432\u044B\u0437\u043E\u0432")),
            React.createElement(Link, { to: group !== 7 && !allLearned
                    ? "/sprint/".concat(group, "/").concat(page)
                    : window.location, style: { textDecoration: 'none' } },
                React.createElement(Button, { variant: "contained", disabled: group === 7 || allLearned ? true : false, sx: { backgroundColor: color } }, "\u0421\u043F\u0440\u0438\u043D\u0442"))),
        React.createElement(CardList, { page: page, group: group, color: color, updateAllLearned: updateAllLearned, allLearned: allLearned }),
        React.createElement(Pagination, { count: group === 7 ? 1 : 30, size: "large", showFirstButton: true, showLastButton: true, page: page, sx: { justifySelf: 'center', alignSelf: 'center', p: 4 }, onChange: function (_, page) {
                if (page !== null) {
                    setPage(page);
                    localStorage.setItem(TextBookConstants.TEXT_BOOK_INFO, JSON.stringify({ group: group, color: color, page: page }));
                }
            } })));
};
